<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol md="12">
          <MetaSection>
            <div class="text-right">
              <ArgonButton :to="{ name: 'Hak Akses' }" isRouteLink outline>
                Kembali</ArgonButton>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol md="12">
          <form action="" @submit.prevent="submit()">
            <cards footerstyle="background-color: #ebeffb;" :useFooter="true">
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <argon-button>Simpan</argon-button>
                    <ArgonButton :to="{ name: 'Hak Akses' }" isRouteLink outline>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <template v-slot:header-action>
                <div>
                  <router-link :to="{ name: 'Master Data Kpi' }" class="btn btn-outline-primary">Kembali</router-link>
                </div>
              </template>
              <FieldsetComponent title="Informasi Hak Akses"
                description="Isi kolom disamping dengan baik dan benar agar nama hak akses bisa terdaftar dalam aplikasi">
                <div class="flex flex-col gap-5">
                  <form-group @keyup="onUpdateName()" label="Nama Hak Akses" idinput="name">
                    <input type="text" name="name" id="name" class="form-control"
                      placeholder="Silakan tulis nama hak akses disini" v-model="data.name">
                  </form-group>

                  <form-group label="Keterangan" idinput="description">
                    <input type="text" name="description" id="description" placeholder="Silakan tulis keterangan"
                      class="form-control" v-model="data.description">
                  </form-group>

                  <form-group label="Label" idinput="label">
                    <input type="text" name="label" id="label" placeholder="Silakan tulis label disini"
                      class="form-control" v-model="data.label" disabled>
                  </form-group>

                  <form-group v-if="this.$route.params.id" label="Status">
                    <div class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="radio" value="1" v-model="data.status" name="status"
                        id="status_0" autocomplete="off">
                      <label class="m-0" :for="'status_0'">Aktif</label>

                      <input style="width: 2rem;height: 2rem;" type="radio" value="0" v-model="data.status" name="status"
                        id="status_1" autocomplete="off">
                      <label class="m-0" :for="'status_1'">Non Aktif</label>
                    </div>
                  </form-group>
                </div>
              </FieldsetComponent>

              <FieldsetComponent title="Hak Akses"
                description="Silakan pilih menu yang diizinkan untuk diakses oleh {roles yang dibuat}.">
                <form-group label="Hak Akses">
                  <div v-for="(models, index) in menus" :key="index" class="card" style="box-shadow: unset;padding-top: 0;padding-bottom: 0;">
                    <div class="card-header py-3" id="headingOne">
                      <div class="d-flex flex-row gap-2 justify-content-between align-items-center">
                        <input @change="onChangePermissions(models)" @click="checkParent(models)" style="width: 2rem;height: 2rem;" type="checkbox" :value="index" :name="'permission_' + models.id" :id="'permission_' + models.id" autocomplete="off" :checked="this.selectedMenus.includes(models.id)">
                        
                        <label class="w-100 m-0" :for="'permission_' + index">{{ models.title ?? "" }}</label>
                        <font-awesome-icon v-if="models.submenu.length > 0" data-bs-toggle="collapse" :href="'#collapse' + index" role="button"
                          aria-expanded="false" :aria-controls="'#collapse' + index" icon="fa-solid fa-angle-down"
                          tabindex="0" @keydown.enter.prevent="toggleCollapse(index)" @keyup.space.prevent="toggleCollapse(index)" />
                        
                      </div>
                      <div class="collapse" v-if="models.submenu.length > 0" :id="'collapse' + index">
                        <div class="card card-body" style="box-shadow: unset;padding-top: 0;padding-bottom: 0;">
                          <div class="row">
                            <div class="col-md-6">
                              <div v-for="(item, indx) in models.submenu" :key="indx" class="d-flex flex-row gap-2 justify-content-between align-items-center">
                                <input @change="onChangePermissions(item)" style="width: 2rem;height: 2rem;" type="checkbox" :value="indx" :name="'permission_' + [item.id].join('_')" :id="'permission_' + [item.id].join('_')" autocomplete="off" :checked="this.selectedMenus.includes(item.id)">
                                <label class="w-100 m-0" :for="'permission_' + [item.id].join('_')">{{ item.title }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-column gap-2">
                    <!-- <div class="d-flex flex-column">
                      <div class="d-flex flex-row gap-2 justify-content-between align-items-center">
                        <input type="checkbox" name="k" id="k">
                        <label class="w-100 m-0" for="">User Delete</label>
                        <span>k</span>
                      </div>
                    </div> -->
                    <!-- <CollapsibleInput v-for="(models, index) in permissions" :key="index" :label="index" :idinput="'collapsible_' + index" :sub="models">
                      <template v-slot:input>
                        <input type="checkbox" :name="'collapsible_' + index" :id="'collapsible_' + index">
                      </template>
                    </CollapsibleInput> -->

                    <!-- <div v-for="(item, index) in permissions" :key="index"
                      class="d-flex flex-row gap-4 align-items-center">
                      <input style="width: 2rem;height: 2rem;" type="checkbox" :value="item.id"
                        @change="onChangePermissions(item.id)"
                        :checked="this.selectedMenus.indexOf(item.id) > -1" name="permission"
                        :id="'permission_' + item.id" autocomplete="off">
                      <label class="m-0" :for="'permission_' + item.id">{{ item.name?.replace("Can ", "") ?? ""
                      }}</label>
                    </div> -->
                  </div>
                </form-group>
              </FieldsetComponent>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<style scoped>
.collapse {
  padding-left: 2.5rem;
}
</style>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import HakAksesApi from "@/repository/api/HakAksesApi";
import FieldsetComponent from "@/views/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import MenuApi from "@/repository/api/MenuApi";
// import CollapsibleInput from "@/components/CollapsibleInput.vue";
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";


export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      data: {},
      unitKerja: [
        {}
      ],
      menus: {},
      selectedMenus: [],
    };
  },
  components: { FieldsetComponent, Cards, FormGroup, ArgonButton, MetaSection, GridRow, GridCol },

  async mounted() {
    if (this.$route.params.id) {
      await this.getData();
    }
    await this.getMenus();
    // await this.getEmployee();
    this.$store.state.isAbsolute = true;
  },
  methods: {
    toggleCollapse(index) {
      const el = document.getElementById('collapse' + index);
      if (el) {
        el.classList.toggle('show');
      }
    },
    checkParent(value) {
      value.submenu.map((item) => {
        return item.id
      }).map((item) => {
        if (this.selectedMenus.indexOf(item) == -1) {
          this.selectedMenus.push(item);
        }
      })
    },
    onUpdateName() {
      this.data.label = this.data.name
      this.data.label = String(this.data.label).toLowerCase().split(' ').join('-')
    },
    getByName(name) {
      let nama = name.split(' ')
      nama.splice(0, 1)
      nama.splice(0, 1)
      nama = nama.map((item) => {
        item = item.split('')
        if (item.length > 0) {
          item[0] = String(item[0]).toUpperCase();
        }
        item = item.join('');
        return item;
      })
      nama = nama.join(" ");
      return String(nama);
    },
    async onChangePermissions(value) {
      let index = this.selectedMenus.findIndex((item) => {
        return item == value.id;
      });
      if (this.selectedMenus.indexOf(value.id) != -1) {
        this.selectedMenus.splice(index, 1);
        if (value?.submenu?.length > 0) {
          value.submenu.forEach(element => {
            index = this.selectedMenus.findIndex((item) => {
              return item == element.id;
            });
            if (index != -1) {
              this.selectedMenus.splice(index, 1)
            }
          });
        }
      }
      else {
        this.selectedMenus.push(value.id);
        if (value.parent != null && value.parent != "") {
          index = this.selectedMenus.findIndex((item) => {
            return item == value.parent;
          })
          
          if (index == -1) {
            this.selectedMenus.push(value.parent)
          }
        }
      }
    },
    async getMenus() {
      MenuApi.getbyparam({parent_only: 1}).then((response) => {
        this.menus = response.data;
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: "ERROR",
          text: error?.response?.data?.message ?? "",
        })
      })
    },
    async submit() {
      this.data.menus = this.selectedMenus;
      let data = new FormData();
      Object.keys(this.data).forEach(item => {
        switch (item) {
          case "menus":
            this.data[item].forEach(element => {
              data.append(item, element);
            });
            break;
          default:
            data.append(item, this.data[item]);
            break;
        }
      });

      if (this.$route.params.id) {
        await HakAksesApi.update(this.$route.params.id, data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Hak Akses" });
          })
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error.response.data.message,
          });
        });
      }
      else {
        await HakAksesApi.post(data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "Hak Akses" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: error?.response?.data?.message ?? "",
          });
        });
      }
    },
    async getData() {
      await HakAksesApi.get(this.$route.params.id).then((response) => {
        this.data = response.data;
        this.data.permissions.forEach(element => {
          this.selectedMenus.push(element.id)
        });
        this.selectedMenus = JSON.parse(JSON.stringify(this.data.menus_id))
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error?.response?.data?.message,
        }).then(() => {
          this.$router.push({ name: "Competencies" });
        });
      })
    }
  },
};
</script>
